import React, { Component } from 'react';
import PageLayout from '../../layouts/pagelayout';
import ReportingSuite from '../../layouts/common/reporting-suite';
import { graphql, useStaticQuery, Link } from 'gatsby';
import CustomImage from '../../components/custom-image';
import BreadCrumb from '../../components/breadcrumb';
import ScrollPositionAnimation from '../../components/scrollpositionanimation';

const AboutUs = () => {
  return (
    <PageLayout pageTitle="Vedanta - About the Report" pageLink="/overview/about-the-report">
      <section className="about-banner">
        <BreadCrumb />
        <div className="section-inner">
          <ScrollPositionAnimation targetElement1="anim-one" targetElement2="anim-two">
            <div className="about-banner-content">
              <div className="about-banner-left">
                <div className="left-to-right anim-one">
                  <CustomImage imageName="aboutus-banner-image.png" alt="Banner image" maxWidth="450" />
                </div>
              </div>

              <div className="about-banner-right">
                <div className="bottom-to-top anim-two">
                  <h2>ABOUT</h2>
                  <h1>VEDANTA LIMITED</h1>
                  <p>
                    Vedanta Limited (Vedanta, VEDL), a subsidiary of Vedanta Resources Limited, is one of the world’s
                    leading natural resources companies with significant operations in Oil &amp; Gas, Zinc, Lead,
                    Silver, Copper, Iron Ore, Steel, and Aluminium &amp; Power, across India, South Africa, Namibia, and
                    Australia.
                  </p>
                </div>
              </div>
            </div>
          </ScrollPositionAnimation>
        </div>
      </section>

      <section className="about-reporting-suite">
        <div className="section-inner">
          <ScrollPositionAnimation targetElement2="anim-three">
            <div className="bottom-to-top anim-three">
              <ReportingSuite></ReportingSuite>
            </div>
          </ScrollPositionAnimation>
        </div>
      </section>

      <section className="about-report-top">
        <div className="about-report-top-inner">
          <ScrollPositionAnimation targetElement2="anim-four">
            <div className="bottom-to-top anim-four">
              <div className="section-inner">
                <div className="about-report-left">
                  <div className="about-report-image">
                    <CustomImage imageName="women-in-mining.jpg" alt="About report img" maxWidth="398" />
                  </div>
                </div>

                <div className="about-report-right">
                  <div className="about-report-desc">
                    <h3>About the report</h3>
                    <p>
                      Inspired by our values, we remain committed to disclosing relevant information pertaining to our
                      material issues, with highest standards of transparency and integrity. It is towards this end that
                      we continue to communicate our annual performance and future strategy through Integrated Reporting
                      (IR). This is our third such report, prepared in accordance with the International Integrated
                      Reporting (IR) Framework, outlined by the International Integrated Reporting Council (IIRC).
                    </p>
                    <p>
                      Our (IR) journey commenced in FY2018 and we were one of the very first natural resources companies
                      in India to publish an integrated report. These reports are prepared to assist our stakeholders,
                      primarily the providers of financial capital, to make an informed assessment of our ability to
                      create value over the short, medium and long term. They strive to demonstrate our confidence,
                      capacity to grow and our ability to deliver on set strategies that can drive significant financial
                      and nonfinancial value for everyone.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </ScrollPositionAnimation>
        </div>
      </section>

      <section className="about-report-btm">
        <div className="about-report-btm-inner">
          <div className="section-inner">
            <div className="report-btm-left-content"></div>
            <ScrollPositionAnimation targetElement2="anim-six">
              <div className="report-btm-right-content">
                <div className="bottom-to-top anim-six">
                  <h6>Scope and boundary</h6>
                  <p>
                    This report covers the reporting period from 1 April 2019 to 31 March 2020 and provides 360°
                    information on Vedanta Limited (Vedanta, VEDL), a subsidiary of Vedanta Resources limited.
                  </p>
                  <p>
                    It provides an overview of operations across our business units, namely, Zinc-Lead-Silver, Oil &
                    Gas, Aluminium, Power, Iron Ore, Steel and Copper. Our assets are spread across India, South Africa
                    and Namibia, and across the value chain comprising exploration, asset development, extraction,
                    processing and value accretion activities.
                  </p>
                  <p>
                    This report aims to provide a concise explanation of VEDL’s performance, strategy, operating model,
                    business outputs and outcomes using a multi-capital approach. It includes measures of engagement
                    with identified material stakeholder groups and outlines the organisation’s governance framework,
                    together with our risk-mitigation Strategy.
                  </p>
                  <h6>Approach to materiality</h6>
                  <p>
                    This report contains information that we believe is of interest to our stakeholders and presents a
                    discussion around matters that can impact our ability to create value over the short, medium and
                    long terms.
                  </p>
                  <h6>Approach to stakeholder engagement</h6>
                  <p>
                    Our stakeholders are those individuals or organisations who have an interest in, and/or whose
                    actions impact our ability to execute our strategy. We periodically engage with different
                    stakeholder groups and actively respond to their concerns and issues.
                  </p>
                  <h6>Annual accounts</h6>
                  <p>
                    This report should be read in conjunction with the annual accounts (page 271 to 502) to gain a
                    complete picture of VEDL’s financial performance.
                  </p>
                  <p>
                    The consolidated and standalone financial statements in our printed report have been prepared in
                    accordance with the Indian Accounting Standards (Ind AS) notified under the Companies (Indian
                    Accounting Standards) Rules, 2015 (as amended from time to time) and have been independently audited
                    by S.R.Batliboi & Co. LLP. The Independent Auditor’s Report for both consolidated and standalone
                    financials can be found on page 271 and 376 respectively.
                  </p>
                  <h6>Board and management assurance</h6>
                  <p>
                    The Board of Directors and the Company’s management acknowledge their responsibility to ensure the
                    integrity of information covered in this report. They believe, to the best of their knowledge, that
                    this report addresses all material issues and presents the integrated performance of VEDL and its
                    impact in a fair and accurate manner. The report has therefore been authorised for release on 06
                    June 2020.
                  </p>
                </div>
              </div>
            </ScrollPositionAnimation>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default AboutUs;
